"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeConn = closeConn;
exports.default = _default;
exports.httpTrackEvent = httpTrackEvent;
exports.openConn = openConn;
exports.waitForClose = waitForClose;
var _debug = _interopRequireDefault(require("debug"));
var _reduxSaga = require("redux-saga");
var _effects = require("redux-saga/effects");
var actions = _interopRequireWildcard(require("../actions"));
var _ws = _interopRequireDefault(require("../services/ws"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const info = (0, _debug.default)('AppFrame:usage-analytics');
function createSender(ws) {
  return function* sendMsg(action) {
    info('Sent a new event:', action.payload);
    yield (0, _effects.call)(_ws.default.send, ws, action.payload);
  };
}
function createListener(chan) {
  return function* listen() {
    while (true) {
      const msg = yield (0, _effects.take)(chan);
      yield (0, _effects.put)(msg);
    }
  };
}
function* waitForClose(senderTask, listener) {
  yield (0, _effects.take)([actions.UA_CLOSED]);
  yield (0, _effects.cancel)(senderTask);
  yield (0, _effects.cancel)(listener);
}
const createSocketEmitter = ws => emit => {
  _ws.default.onClose(ws, reason => {
    emit(actions.closeUsageAnalytics(reason));
  });
  return () => _ws.default.close(ws);
};
function* closeConn(action) {
  yield (0, _effects.call)(info, 'Established WS connection for UA was closed', action.payload);
}
function* openConn(action) {
  try {
    const ws = yield (0, _effects.call)(_ws.default.open, action.payload.hostname, action.payload.protocol, action.payload.path);
    yield (0, _effects.put)(actions.usageAnalyticsOpenSuccess());
    _ws.default.onClose(ws, reason => {
      info('UA websocket has been closed:', reason);
    });
    const chan = (0, _reduxSaga.eventChannel)(createSocketEmitter(ws));
    const listener = yield (0, _effects.fork)(createListener(chan));
    const sender = yield (0, _effects.takeEvery)(actions.UA_MSG_SEND, createSender(ws));
    yield (0, _effects.spawn)(waitForClose, sender, listener);
    if (action.payload.trackLogin) {
      yield (0, _effects.put)(actions.usageAnalyticsSendMessage('AppFrame', 'Action', 'Login', window.location.pathname, 'ua'));
      info('UA tracked a login action');
    }
    info('Establish WS connection for UA by path:', action.payload);
  } catch (error) {
    info('Cannot establish WS connection for UA', error && error.message);
  }
}
function* httpTrackEvent(action) {
  const config = yield (0, _effects.getContext)('config');
  if (config.apiPrefixes.uaGW) {
    try {
      const uaApi = yield (0, _effects.getContext)('uaApi');
      yield (0, _effects.call)(uaApi.trackEvent, action.payload);
      info('UA tracked event');
    } catch (error) {
      info('Cannot capture UA event', error && error.message);
    }
  }
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeEvery)(actions.UA_MSG_SEND, httpTrackEvent), (0, _effects.takeLatest)(actions.UA_OPEN_PENDING, openConn), (0, _effects.takeLatest)(actions.UA_CLOSED, closeConn)]);
}